import { render, staticRenderFns } from "./CustomerActionsDesktop.vue?vue&type=template&id=755650e1&"
import script from "./CustomerActionsDesktop.vue?vue&type=script&lang=ts&"
export * from "./CustomerActionsDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports